import React, { useState } from 'react'
import { postInsertarNPCCentrosMP, postVerificarExistenciaCenCostYCuentasMP } from '../../../services/Contratacion'
import ModalErrorNPCCentros from './ModalErrorNPCCentros'

const ModalCrearCuentasMP = ({setmodalOnCrearNPCCentros,dataUnMaestroProcedimiento,setactualizarData}) => {
    const [errorSeleccionarVigencia, seterrorSeleccionarVigencia]=useState('Seleccionar Vigencia')
    const [errorSeleccionarEmpresa, seterrorSeleccionarEmpresa]=useState('Seleccionar Empresa')
    const [errorSeleccionarCentroCosto, seterrorSeleccionarCentroCosto]=useState('Seleccionar Centro Costo')
    const [errorSeleccionarCuentaCosto, seterrorSeleccionarCuentaCosto]=useState('Seleccionar cuenta costo')
    const [errorCentroIngreso, seterrorCentroIngreso]=useState('Seleccionar Cuenta de Ingreso')
    const [mensajeError, setmensajeError]=useState('')
    const [modalOnErrorNPCCentros, setmodalOnErrorNPCCentros]=useState(false)
    
    const [loading, setloading]=useState(false)

    const handleCancelarClick=()=>{
        setmodalOnCrearNPCCentros(false)
    }

    const handleOnsubmitCrearCuenta=(e)=>{
        e.preventDefault()
        const dataInsert={
            "PRCODI": dataUnMaestroProcedimiento.PRCODI,
            "PrcCCosV": e.target.centroCosto.value,
            "PrcVig":   e.target.vigencia.value,
            "PrEmpCt1V":e.target.empresa.value,
            "PrcCtaIngV":e.target.cuentaIngreso.value,
            "PrcCtaCosV":e.target.cuentaCosto.value
        }

        const dataValidar={
            "PRCODI": dataUnMaestroProcedimiento.PRCODI,
            "CNCCOD":e.target.centroCosto.value,
            "EMPCOD":e.target.empresa.value,
            "CntVig":e.target.vigencia.value,
            "CntCod":e.target.cuentaCosto.value,
            "PrcCtaIngV":e.target.cuentaIngreso.value,
            "CntEst":'S'
        }
        
        
        if(!errorSeleccionarVigencia && !errorSeleccionarEmpresa && !errorSeleccionarCentroCosto && !errorSeleccionarCuentaCosto
            && !errorCentroIngreso
        ){
            setloading(true)
            postVerificarExistenciaCenCostYCuentasMP(dataValidar).then((res)=>{
                console.log(res.data,'validaciones')
                if(!(res.data.foundCenCost)){
                    setloading(false)
                    setmensajeError(res.data.messageCenCost)
                    setmodalOnErrorNPCCentros(true)                    
                }else if(!(res.data.foundCuentas)){
                    setloading(false)
                    setmensajeError(res.data.messageCuentas)
                    setmodalOnErrorNPCCentros(true)
                }else if(res.data.foundMaeprov){
                    setloading(false)
                    setmensajeError(res.data.messageMaeprov)
                    setmodalOnErrorNPCCentros(true)
                }else if(!(res.data.foundCuentasDos)){
                    setloading(false)
                    setmensajeError(res.data.messageCuentasDos)
                    setmodalOnErrorNPCCentros(true)
                }
                else{
                    postInsertarNPCCentrosMP(dataInsert).then((res)=>{
                         setloading(false)
                        setmensajeError('')
                        setactualizarData(dataInsert)
                        setmodalOnCrearNPCCentros(false)
                    })
                }
            })
            
        }
    }

    const handleOnchangeVigencia=(e)=>{
        if(e.target.value){
            seterrorSeleccionarVigencia('')
        }else{
            seterrorSeleccionarVigencia('Seleccionar Vigencia')
        }
    }

    const handleOnchangeEmpresa=(e)=>{
        if(e.target.value){
            seterrorSeleccionarEmpresa('')
        }else{
            seterrorSeleccionarEmpresa('Seleccionar Empresa')
        }
    }

    const handleOnchangeCentroCosto=(e)=>{
        if(e.target.value){
            seterrorSeleccionarCentroCosto('')
        }else{
            seterrorSeleccionarCentroCosto('Seleccionar Cuenta Contable')
        }
    }

    const handleOnchangeCuentaCosto=(e)=>{
        if(e.target.value){
            seterrorSeleccionarCuentaCosto('')
        }else{
            seterrorSeleccionarCuentaCosto('Seleccionar cuenta costo')
        }
    }

    const handleOnchangeCentroIngreso=(e)=>{
        if(e.target.value){
            seterrorCentroIngreso('')
        }else{
            seterrorCentroIngreso('Seleccionar Cuenta de Ingreso')
        }
    }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-2xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Crear NPC Centros
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-1">
            <form onSubmit={handleOnsubmitCrearCuenta}>
              <div className="flex  text-left">
                
                <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Vigencia
                  </label>
                  
                  <input
                    onChange={handleOnchangeVigencia}
                    name='vigencia'
                    type="number"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarVigencia}
                  </label>
                  </div>
                  <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Empresa
                  </label>
                  
                  <input
                    onChange={handleOnchangeEmpresa}
                    name='empresa'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarEmpresa}
                  </label>
                  </div>
                  
              </div>
              <div className="flex  text-left">
                
                <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Centro Costo
                  </label>
                  
                  <input
                    onChange={handleOnchangeCentroCosto}
                    name='centroCosto'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarCentroCosto}
                  </label>
                    
                  </div>
                  <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Cuenta de Costo
                  </label>
                  
                  <input
                    onChange={handleOnchangeCuentaCosto}
                    name='cuentaCosto'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorSeleccionarCuentaCosto}
                  </label>
                  </div>
                  
              </div>
              <div className="flex  text-left">
                
                <div className="w-1/2  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Cuenta de ingreso
                  </label>
                  
                  <input
                    onChange={handleOnchangeCentroIngreso}
                    name='cuentaIngreso'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    autoComplete='off'
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorCentroIngreso}
                  </label>
                    
                  </div>
                  
                  
              </div>
            
          
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button type="submit"
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button>
          </div>
          </form>
          </div>
        </div>
      </div>
      {loading &&
      <div className="relative flex items-center justify-center h-screen">
      <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
          <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
              <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
              <p className="mt-4 text-lg">Cargando</p>
          </div>
      </div>
      <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
  </div>}
      {modalOnErrorNPCCentros? <ModalErrorNPCCentros setmodalOnErrorNPCCentros={setmodalOnErrorNPCCentros} mensajeError={mensajeError}/>:null}
    </div>
  )
}

export default ModalCrearCuentasMP